import { render, staticRenderFns } from "./AddAcount.vue?vue&type=template&id=2512e272&scoped=true&"
import script from "./AddAcount.vue?vue&type=script&lang=ts&"
export * from "./AddAcount.vue?vue&type=script&lang=ts&"
import style0 from "./AddAcount.vue?vue&type=style&index=0&id=2512e272&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2512e272",
  null
  
)

export default component.exports